import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { useAxios } from 'packages/core'
import { useTranslation } from 'react-i18next'
import { useNotification } from 'packages/eid-ui'
import { usePageContext } from 'pageContext'
import useApiWithInfiniteScroll from './useApiWithInfiniteScroll'
import { useQuery as useCoreQuery } from 'packages/core'
import { showSearchToLoadMessage } from 'utils'
import { useHistory } from 'react-router-dom'

export const CSV_INBOX_KEY = 'CSV_INBOX'

export const useCsvInbox = (id: any) => {
    const callApi = useAxios()
    const query = useCoreQuery()

    return useQuery(
        [CSV_INBOX_KEY, id],
        () =>
            callApi({
                method: 'GET',
                url: `/api/rta/csvinbox/${id}`,
                // url: `/api/csvinbox/${id}`,
            }).then((data) => data.data),
        {
            enabled: Boolean(id),
        },
    )
}

export const useCSVInboxItems = () => {
    const [state]: any = usePageContext()
    const history = useHistory()

    const {
        location: { pathname },
    } = history

    const {
        searchTerm,

        sortOrder,
        sortBy,
        status,
        itemType,
        ownedBy,
        shouldLoadTags,
        advancedSearchTags,
        includeBasicClaimSet,
        isEnterPressed,
        inboxType,
        inboxCategory,
        uploadStatus,
        uploadedAfter,
        uploadedBefore,
        trackingID,

    } = state
    const ownerPersonId = ownedBy?.id
   

    const callApi = useAxios()

    const queryData: any = {}

    if (searchTerm) {
        queryData.searchTerm = searchTerm
    }
    if (sortBy) {
        queryData.sortBy = sortBy
    }
    if (sortOrder) {
        queryData.desc = sortOrder === 'desc'
    }
    if (inboxType) {
        queryData.csvInboxTypeIDs = inboxType.map((x: any) => x.id)
    }
    if (inboxCategory) {
        queryData.csvInboxCategoryId = inboxCategory?.csvInboxCategoryID
    }
    if (uploadStatus) {
        queryData.uploadStatus = uploadStatus
    }
    if (shouldLoadTags) {
        queryData.includeTags = true
    }

    if (advancedSearchTags) {
        queryData.tags = advancedSearchTags
    }
    if (includeBasicClaimSet) {
        queryData.includeBasicClaimSet = includeBasicClaimSet === 'true'
    }
    if (ownedBy) {
        queryData.createdByPersonID = ownedBy.id
    }
    if (uploadedAfter) {
        queryData.uploadedAfter = uploadedAfter
    }
    if (uploadedBefore) {
        queryData.uploadedBefore = uploadedBefore
    }
    if (trackingID) {
        queryData.trackingID = trackingID
    }

    const endpoint = `/api/RTA/csvinbox/search`
    // const endpoint = `/api/CSVInbox/search`

    return useApiWithInfiniteScroll(
        [
            CSV_INBOX_KEY,
            'LIST_MY_CSV_INBOX',
            // tab.path,
            searchTerm,
            sortBy,
            sortOrder,
            uploadStatus,
            status,
            itemType,
            ownerPersonId,
            uploadedAfter,
            uploadedBefore,
            trackingID,
            advancedSearchTags,
            shouldLoadTags,
            includeBasicClaimSet,
            inboxType,
            inboxCategory,
        ],
        (skip: any, take: any) => {
            return callApi({
                url: endpoint,
                method: 'POST',
                data: {
                    ...queryData,
                    skip,
                    take,
                },
            })
        },
        {
            enabled: Boolean(
                !showSearchToLoadMessage(pathname, searchTerm, isEnterPressed),
            ),
        },
    )
}

export const useCSVInboxTypes = (enabled: boolean) => {
    const callApi = useAxios()
    return useQuery(
        [CSV_INBOX_KEY, 'TYPES'],
        () =>
            callApi({
                method: 'GET',
                url: '/api/csvinbox/types',
            }).then((data) => data.data),
        {
            enabled: enabled,
        },
    )
}

export const useCSVInboxCategories = (enabled: boolean) => {
    const callApi = useAxios()
    return useQuery(
        [CSV_INBOX_KEY, 'CATEGORIES'],
        () =>
            callApi({
                method: 'GET',
                url: '/api/csvinbox/categories',
            }).then((data) => data.data),
        {
            enabled: enabled,
        },
    )
}

export const useUploadCSVInbox = () => {
    const callApi = useAxios()
    const { showSuccessMessage, showWarningMessage } = useNotification()
    const { t } = useTranslation()

    return useMutation(
        (formData: any) =>
            callApi({
                method: 'POST',
                url: `/api/CSVInbox/upload`,
                data: formData,
            }),
        {
            // onSuccess: (data) => {
            //     debugger
            //     if (data?.data?.isSuccess) {
            //         showSuccessMessage(data.data.message)
            //     } else {
            //         showWarningMessage(data.data.message)
            //     }
            // },
            // onError: () => {
            //     showWarningMessage(t('CSVInboxUploadFailed'))
            // },
        },
    )
}

export const useApplicationWorkflows = (
    noun: string,
    verb: string,
    id?: string,
) => {
    const [state]: any = usePageContext()
    const { searchTerm } = state

    let url = `api/UIActions/byNoun?noun=${noun}&verb=${verb}`
    if (searchTerm) {
        url = url + `&searchTerm=${searchTerm}`
    }

    const callApi = useAxios()
    return useQuery(
        [CSV_INBOX_KEY, 'WORKFLOWS', id, noun, verb, searchTerm],
        () =>
            callApi({
                method: 'GET',
                url: url,
            }).then((data) => data.data),
    )
}

export const useTreeFilterAPI = (
    treeUrl: string,
    parentId: any,
    rootId: any,
    searchTerm: any,
    fetchChildren: boolean | null | undefined,
) => {
    const callApi = useAxios()

    let apiUrl = `${treeUrl}`
    if (parentId) {
        apiUrl = `${apiUrl}&parentId=${parentId}`
    }
    if (rootId) {
        apiUrl = `${apiUrl}&rootId=${rootId}`
    }
    if (searchTerm) {
        apiUrl = `${apiUrl}&search=${searchTerm}`
    }

    return useQuery(
        ['TREE_FILTER_WITH_SEARCH', apiUrl, searchTerm, rootId, parentId],
        () =>
            callApi({
                method: 'GET',
                url: apiUrl,
            }).then((data) => data.data),
        {
            enabled: Boolean(treeUrl) && Boolean(fetchChildren),
            cacheTime: 0,
        },
    )
}

export const useLandscapes = (
    trackingID: string,
    excludeNonPromoted: boolean = false,
) => {
    const callApi = useAxios()
    return useQuery(
        [CSV_INBOX_KEY, 'LANDSCAPES', trackingID],
        () =>
            callApi({
                method: 'POST',
                url: `/api/RTA/csvinboxlandscape/trackingid`,
                data: {
                    trackingID: trackingID,
                    excludeNonPromoted: excludeNonPromoted,
                },
            }).then((data) => data.data),
        {
            enabled: Boolean(trackingID),
        },
    )
}

export const useGroupToBusinessRoleItems = (
    trackingID: string,
    statusId: number,
) => {
    const [state]: any = usePageContext()

    const {
        searchTerm,
        groupSelection,
        sortOrder,
        sortBy,
        landscapes,
        orgRoleOrgZoneSelection,
        orgRoleSelection,
        orgZoneSelection,
        accountStoreSelection,
    } = state

    const callApi = useAxios()

    const queryData: any = {}

    if (searchTerm) {
        queryData.searchTerm = searchTerm
    }
    if (sortBy) {
        queryData.sortBy = sortBy
    }
    if (sortOrder) {
        queryData.desc = sortOrder === 'desc'
    }
    if (landscapes) {
        queryData.rtA_LandscapeIDList = landscapes.map((x: any) => x.id)
    }
    if (statusId) {
        queryData.rtA_CSVInboxItemStatusID = statusId
    }
    if (trackingID) {
        queryData.trackingID = trackingID
    }
    if (groupSelection) {
        queryData.groupGUID = groupSelection.id
    }
    if (orgRoleOrgZoneSelection) {
        queryData.orgRoleOrgZoneGUID = orgRoleOrgZoneSelection.id
    }
    if (orgRoleSelection) {
        queryData.orgRoleGUID = orgRoleSelection.id
    }
    if (orgZoneSelection) {
        queryData.orgZoneGUID = orgZoneSelection.id
    }
    if (accountStoreSelection) {
        queryData.accountStoreGUID = accountStoreSelection.id
    }

    const endpoint = `/api/RTA/GroupToBusinessRole/search`

    return useApiWithInfiniteScroll(
        [
            CSV_INBOX_KEY,
            'LIST_GROUP_TO_BUSINESS_ROLE',
            // tab.path,
            searchTerm,
            sortBy,
            sortOrder,
            trackingID,
            landscapes,
            statusId,
            groupSelection,
            orgRoleOrgZoneSelection,
            orgRoleSelection,
            orgZoneSelection,
            accountStoreSelection,
        ],
        (skip: any, take: any) => {
            return callApi({
                url: endpoint,
                method: 'POST',
                data: {
                    ...queryData,
                    skip,
                    take,
                },
            })
        },
        {
            enabled: Boolean(trackingID) && landscapes !== '',
        },
    )
}

export const useUpdateGroupToBusinessRoleItemStatus = () => {
    const callApi = useAxios()

    return useMutation((data) =>
        callApi({
            method: 'PUT',
            url: '/api/RTA/grouptobusinessrole/updatestatus',
            data: data,
        }),
    )
}
export const useGroupToBusinessRoleUpdate = () => {
    const callApi = useAxios()

    return useMutation((data) =>
        callApi({
            method: 'PUT',
            url: '/api/RTA/grouptobusinessrole/update',
            data: data,
        }),
    )
}

export const useInboxItemStatues = (enabled: boolean) => {
    const callApi = useAxios()
    return useQuery(
        [CSV_INBOX_KEY, 'INBOX_ITEM_STATUES'],
        () =>
            callApi({
                method: 'POST',
                url: `/api/RTA/inboxitemstatus`,
            }).then((data) => data.data),
        {
            enabled: enabled,
        },
    )
}

export const useRevalidate = (url: string) => {
    const callApi = useAxios()
    const { showSuccessMessage, showWarningMessage } = useNotification()
    const { t } = useTranslation()

    return useMutation(
        (data: any) =>
            callApi({
                method: 'POST',
                url: url,
                data: data,
            }),
        {
            onSuccess: (data: any) => {
                if (data?.data?.isSuccess) {
                    showSuccessMessage(data.data.message)
                } else {
                    showWarningMessage(data.data.message)
                }
            },
            onError: () => {
                showWarningMessage(t('RevalidateFailed'))
            },
        },
    )
}
export const usePromoteCSVInboxLandscape = () => {
    const callApi = useAxios()
    const { showSuccessMessage, showWarningMessage } = useNotification()
    const { t } = useTranslation()

    return useMutation(
        (data: any) =>
            callApi({
                method: 'POST',
                url: '/api/RTA/csvinboxlandscape/promote',
                data: data,
            }),
        {
            onSuccess: (data) => {
                if (data?.data?.isSuccess) {
                    showSuccessMessage(data.data.message)
                } else {
                    showWarningMessage(data.data.message)
                }
            },
            onError: () => {
                showWarningMessage(t('PromoteCSVInboxLandscapeFailed'))
            },
        },
    )
}

export const usePublishQueue = (url: string) => {
    const callApi = useAxios()
    const { showSuccessMessage, showWarningMessage } = useNotification()
    const { t } = useTranslation()

    return useMutation(
        (data: any) =>
            callApi({
                method: 'POST',
                url: url,
                data: data,
            }),
        {
            onSuccess: (data) => {
                if (data?.data?.isSuccess) {
                    showSuccessMessage(data.data.message)
                } else {
                    showWarningMessage(data.data.message)
                }
            },
            onError: () => {
                showWarningMessage(t('PublishQueueFailed'))
            },
        },
    )
}

export const useGroupEligibilityItems = (
    trackingID: string,
    statusId: number,
) => {
    const [state]: any = usePageContext()

    const {
        searchTerm,
        groupSelection,
        sortOrder,
        sortBy,
        landscapes,
        assigneeSelection,
        accountStoreSelection,
    } = state

    const callApi = useAxios()

    const queryData: any = {}

    if (searchTerm) {
        queryData.searchTerm = searchTerm
    }
    if (sortBy) {
        queryData.sortBy = sortBy
    }
    if (sortOrder) {
        queryData.desc = sortOrder === 'desc'
    }
    if (landscapes) {
        queryData.rtA_LandscapeIDList = landscapes.map((x: any) => x.id)
    }
    if (statusId) {
        queryData.rtA_CSVInboxItemStatusID = statusId
    }
    if (trackingID) {
        queryData.trackingID = trackingID
    }
    if (groupSelection) {
        queryData.groupGUID = groupSelection.id
    }
    if (assigneeSelection) {
        queryData.assigneeGUID = assigneeSelection.id
    }
    if (accountStoreSelection) {
        queryData.accountStoreGUID = accountStoreSelection.id
    }

    const endpoint = `/api/RTA/GroupEligibility/search`

    return useApiWithInfiniteScroll(
        [
            CSV_INBOX_KEY,
            'LIST_GROUP_ELIGIBILITY',
            searchTerm,
            sortBy,
            sortOrder,
            trackingID,
            landscapes,
            statusId,
            groupSelection,
            assigneeSelection,
            accountStoreSelection,
        ],
        (skip: any, take: any) => {
            return callApi({
                url: endpoint,
                method: 'POST',
                data: {
                    ...queryData,
                    skip,
                    take,
                },
            })
        },
        {
            enabled: Boolean(trackingID) && landscapes !== '',
        },
    )
}

export const useUpdateGroupEligibilityItemStatus = () => {
    const callApi = useAxios()

    return useMutation((data) =>
        callApi({
            method: 'PUT',
            url: '/api/RTA/groupeligibility/updatestatus',
            data: data,
        }),
    )
}
export const useGroupEligibilityUpdate = () => {
    const callApi = useAxios()

    return useMutation((data) =>
        callApi({
            method: 'PUT',
            url: '/api/RTA/groupeligibility/update',
            data: data,
        }),
    )
}
export const useCloseInboxProcess = () => {
    const callApi = useAxios()

    return useMutation((data) =>
        callApi({
            method: 'PUT',
            url: '/api/RTA/closeupload',
            data: data,
        }),
    )
}

export const useApplicationRoleAttributeItems = (
    trackingID: string,
    statusId: number,
) => {
    const [state]: any = usePageContext()

    const {
        searchTerm,
        groupSelection,
        sortOrder,
        sortBy,
        landscapes,
        assigneeSelection,
        accountStoreSelection,
        highLevelClassification,
    } = state

    const callApi = useAxios()

    const queryData: any = {}

    if (searchTerm) {
        queryData.searchTerm = searchTerm
    }
    if (sortBy) {
        queryData.sortBy = sortBy
    }
    if (sortOrder) {
        queryData.desc = sortOrder === 'desc'
    }
    if (landscapes) {
        queryData.rtA_LandscapeIDList = landscapes.map((x: any) => x.id)
    }
    if (statusId) {
        queryData.rtA_CSVInboxItemStatusID = statusId
    }
    if (trackingID) {
        queryData.trackingID = trackingID
    }
    if (groupSelection) {
        queryData.groupGUID = groupSelection.id
    }
    if (assigneeSelection) {
        queryData.assigneeGUID = assigneeSelection.id
    }
    if (accountStoreSelection) {
        queryData.accountStoreGUID = accountStoreSelection.id
    }
    if (highLevelClassification) {
        queryData.highLevelClassification = highLevelClassification
    }   

    const endpoint = `/api/RTA/groupAttributes/search`

    return useApiWithInfiniteScroll(
        [
            CSV_INBOX_KEY,
            'LIST_APPLICATION_ROLE_ATTRIBUTE',
            searchTerm,
            sortBy,
            sortOrder,
            trackingID,
            landscapes,
            statusId,
            groupSelection,
            assigneeSelection,
            accountStoreSelection,
            highLevelClassification,
        ],
        (skip: any, take: any) => {
            return callApi({
                url: endpoint,
                method: 'POST',
                data: {
                    ...queryData,
                    skip,
                    take,
                },
            })
        },
        {
            enabled: Boolean(trackingID) && landscapes !== '',
        },
    )
}


export const useUpdateApplicationRoleAttributeItemStatus = () => {
    const callApi = useAxios()

    return useMutation((data) =>
        callApi({
            method: 'PUT',
            url: '/api/RTA/groupattributes/updatestatus',
            data: data,
        }),
    )
}
export const useApplicationRoleAttributeUpdate = () => {
    const callApi = useAxios()

    return useMutation((data) =>
        callApi({
            method: 'PUT',
            url: '/api/RTA/groupattributes/update',
            data: data,
        }),
    )
}



export const useTemplateBusinessRoleItems = (
    trackingID: string,
    statusId: number,
) => {
    const [state]: any = usePageContext()

    const {
        searchTerm,
        groupSelection,
        sortOrder,
        sortBy,
        landscapes,
        assigneeSelection,
        accountStoreSelection,
        highLevelClassification,
    } = state

    const callApi = useAxios()

    const queryData: any = {}

    if (searchTerm) {
        queryData.searchTerm = searchTerm
    }
    if (sortBy) {
        queryData.sortBy = sortBy
    }
    if (sortOrder) {
        queryData.desc = sortOrder === 'desc'
    }
    if (landscapes) {
        queryData.rtA_LandscapeIDList = landscapes.map((x: any) => x.id)
    }
    if (statusId) {
        queryData.rtA_CSVInboxItemStatusID = statusId
    }
    if (trackingID) {
        queryData.trackingID = trackingID
    }
    if (groupSelection) {
        queryData.groupGUID = groupSelection.id
    }
    if (assigneeSelection) {
        queryData.assigneeGUID = assigneeSelection.id
    }
    if (accountStoreSelection) {
        queryData.accountStoreGUID = accountStoreSelection.id
    }
    if (highLevelClassification) {
        queryData.highLevelClassification = highLevelClassification
    }

    const endpoint = `/api/RTA/templatebusinessrole/search`

    return useApiWithInfiniteScroll(
        [
            CSV_INBOX_KEY,
            'LIST_TEMPLATE_BUSINESS_ROLE',
            searchTerm,
            sortBy,
            sortOrder,
            trackingID,
            landscapes,
            statusId,
            groupSelection,
            assigneeSelection,
            accountStoreSelection,
            highLevelClassification,
        ],
        (skip: any, take: any) => {
            return callApi({
                url: endpoint,
                method: 'POST',
                data: {
                    ...queryData,
                    skip,
                    take,
                },
            })
        },
        {
            enabled: Boolean(trackingID) && landscapes !== '',
        },
    )
}


export const useUpdateTemplateBusinessRoleItemStatus = () => {
    const callApi = useAxios()

    return useMutation((data) =>
        callApi({
            method: 'PUT',
            url: '/api/RTA/templatebusinessrole/updatestatus',
            data: data,
        }),
    )
}
export const useTemplateBusinessRoleUpdate = () => {
    const callApi = useAxios()

    return useMutation((data) =>
        callApi({
            method: 'PUT',
            url: '/api/RTA/templatebusinessrole/update',
            data: data,
        }),
    )
}

export const useDerivedBusinessRoleItems = (
    trackingID: string,
    statusId: number,
) => {
    const [state]: any = usePageContext()

    const {
        searchTerm,
        groupSelection,
        sortOrder,
        sortBy,
        landscapes,
        assigneeSelection,
        accountStoreSelection,
    } = state

    const callApi = useAxios()

    const queryData: any = {}

    if (searchTerm) {
        queryData.searchTerm = searchTerm
    }
    if (sortBy) {
        queryData.sortBy = sortBy
    }
    if (sortOrder) {
        queryData.desc = sortOrder === 'desc'
    }
    if (landscapes) {
        queryData.rtA_LandscapeIDList = landscapes.map((x: any) => x.id)
    }
    if (statusId) {
        queryData.rtA_CSVInboxItemStatusID = statusId
    }
    if (trackingID) {
        queryData.trackingID = trackingID
    }
    if (groupSelection) {
        queryData.groupGUID = groupSelection.id
    }
    if (assigneeSelection) {
        queryData.assigneeGUID = assigneeSelection.id
    }
    if (accountStoreSelection) {
        queryData.accountStoreGUID = accountStoreSelection.id
    }

    const endpoint = `/api/RTA/derivedbusinessrole/search`

    return useApiWithInfiniteScroll(
        [
            CSV_INBOX_KEY,
            'LIST_DERIVED_BUSINESS_ROLE',
            searchTerm,
            sortBy,
            sortOrder,
            trackingID,
            landscapes,
            statusId,
            groupSelection,
            assigneeSelection,
            accountStoreSelection,
        ],
        (skip: any, take: any) => {
            return callApi({
                url: endpoint,
                method: 'POST',
                data: {
                    ...queryData,
                    skip,
                    take,
                },
            })
        },
        {
            enabled: Boolean(trackingID) && landscapes !== '',
        },
    )
}


export const useUpdateDerivedBusinessRoleItemStatus = () => {
    const callApi = useAxios()

    return useMutation((data) =>
        callApi({
            method: 'PUT',
            url: '/api/RTA/derivedbusinessrole/updatestatus',
            data: data,
        }),
    )
}
export const useDerivedBusinessRoleUpdate = () => {
    const callApi = useAxios()

    return useMutation((data) =>
        callApi({
            method: 'PUT',
            url: '/api/RTA/derivedbusinessrole/update',
            data: data,
        }),
    )
}
